import { useState } from 'react';
import { LuEye, LuEyeOff } from 'react-icons/lu';
import { IconButton } from '../IconButton';
import { GenericPasswordInputWrapper } from './styles';

export default function PasswordInput({
    parentProps,
    inputProps,
}: {
    parentProps?: React.InputHTMLAttributes<HTMLDivElement>;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}) {
    const [isPasswordVisible, setPasswordVisible] = useState(false);

    return (
        <GenericPasswordInputWrapper
            aria-invalid={parentProps && parentProps['aria-invalid']}
        >
            <input
                id='password'
                type={isPasswordVisible ? 'text' : 'password'}
                {...inputProps}
            />
            <IconButton
                type="button"
                children={isPasswordVisible ? <LuEye /> : <LuEyeOff />}
                onClick={() => setPasswordVisible(e => !e)}
            />
        </GenericPasswordInputWrapper>
    );
}
